import React from 'react';

import { Button, Grid, Typography } from '@mui/material';

import FormCandidateSection from '../FormCandidateSection';
import useApp from '../hooks/useApp';
import { SECTION_TYPES } from '../../../consts';

const FormCandidateSectionList = ({
  schema,
}) => {
  const {
    handleSendForm,
  } = useApp();

  return (
    <Grid container direction="column" gap={2}>
      {schema ? Object.keys(schema).map((key) => {
        const sectionType = schema[key].type || SECTION_TYPES.base;
        return (
          <FormCandidateSection
            key={key}
            sectionType={sectionType}
            sectionCode={key}
            schema={schema}
          />
        )
      }) : null}
      <Button
        size='large'
        variant="contained"
        onClick={handleSendForm}
      >Отправить анкету</Button>
      <Typography variant="caption">
        Нажимая кнопку «Отправить анкету», Вы заверяете, что информация, которую Вы изложили в настоящей анкете, является достоверной и действительной на настоящий момент.
        Вы, в соответствии со ст. 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных», даёте согласие НАО «Красная поляна», юридический адрес: индекс 354000, Россия, Краснодарский край, г. Сочи, ул. Северная, дом 14 «А» тел. +7(8622) 43 91 10 (далее Общество), на автоматизированную, а также без использования средств автоматизации обработку Ваших персональных данных, а именно: фамилия, имя, отчество; дата рождения; место рождения; паспортные данные (для иностранных граждан документы, дающие право на ведение трудовой деятельности в РФ (патент, миграционная карта, вид на жительство); ИНН; адрес регистрации и проживания; семейное положение; состав семьи (степень родства фамилия, имя, отчество, дата рождения, контактный телефон); сведения об образовании включая специальность, учебное заведение, период и форма обучения; сведения о предыдущих местах работы (период работы, наименование организации, должность, служебные обязанности, причина увольнения); информация о воинской обязанности; данные о документе, подтверждающий регистрацию в системе индивидуального (персонифицированного) учета, в том числе в форме электронного документа; судимости или привлечения к административной ответственности; адрес электронной почты; телефон. Данные для обработки с целью принятия решения о моем трудоустройстве в Общество, соблюдения трудового законодательства Российской Федерации, законодательства Российской Федерации об охране труда и техники безопасности, законодательства Российской Федерации об охране здоровья; организации пропуска на территорию, на которой находится Общество.
      </Typography>
    </Grid>
  );
};

export default FormCandidateSectionList;